import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import './index.scss';
import { getNodeHeight, flat, childranizePath, setNode, getNode, setNodeChildren, preserveExpanded, checkNodeArrayPath, createTargetNodeSetter, getAllChildrenSelected } from '.';

export const DEFAULT_TRANSITION_TIME = 150;
export const DEFAULT_NODE_HEIGHT = 21;

@Component
export class SelectTree extends Vue {
  @Prop({ required: true }) tree;
  @Prop({ required: true }) tree;

  treeObj = [];

  @Watch('tree', { immediate: true }) treeHandler(newValue, oldValue) {
    if (this.treeObj && this.treeObj.length > 0) {
      console.log(preserveExpanded(newValue, this.treeObj));
      this.treeObj = preserveExpanded(newValue, this.treeObj);
    } else {
      this.treeObj = newValue;
    }
  }

  onSelect(e, el) {
    // const selected = e.target.checked;
    el.selected = !el.selected
    // this.treeObj = setNode(el)({
    //   ...setNodeChildren(el, 'selected', selected)
    // }, this.treeObj);

    this.treeObj = checkNodeArrayPath(this.treeObj, el, {
      nodeSetter: createTargetNodeSetter(el.path, 'selected', el.selected),
      selectFunc: getAllChildrenSelected
    });

    this.$emit('changed', this.treeObj);

  }



  onExpand(el) {
    // if (el.expanded) {
    //   return;
    // }
    // const elPath = childranizePath(el.path);
    // this.treeObj = set(lensPath([...elPath, 'expanded']), true, this.treeObj);

    this.treeObj = setNode(el)({
      ...el,
      expanded: true
    }, this.treeObj);


    // console.log([...childranizePath(el.path), 'expanded'], this.treeObj, el.expanded);
    const nodeHeight = getNodeHeight(getNode(el)(this.treeObj)) - DEFAULT_NODE_HEIGHT;

    const treeChildId = this.treeChildId(el);
    const treeChild = document.getElementById(treeChildId);
    this.expandAnimation(treeChild, nodeHeight);

    // console.log({treeChildId, nodeHeight});

  }

  expandAnimation(element, height) {
    // element.style.display = 'block';
    element.style.height = `${height}px`;
    setTimeout(() => {
      element.style.height = `auto`;
    }, DEFAULT_TRANSITION_TIME);
  }
  minimizeAnimation(element) {
    const height = element.getBoundingClientRect().height || 0;
    element.style.height = `${height}px`;
    setTimeout(() => {
      element.style.height = `0px`;
    });
  }
  treeIcons(el) {
    return el.selected && flat(el.children).every(e => e.selected) ? 'checkbox-tick' : !el.selected && flat(el.children).every(e => !e.selected) ? 'checkbox' : 'checkbox-minus'

  }
  onMinimize(el) {
    // const elPath = childranizePath(el.path);


    this.treeObj = setNode(el)({
      ...el,
      expanded: false
    }, this.treeObj);

    // console.log([...childranizePath(el.path), 'expanded'], this.treeObj);


    const treeChildId = this.treeChildId(el);
    const treeChild = document.getElementById(treeChildId);

    this.minimizeAnimation(treeChild);
  }

  treeChildId(el) {
    return `${el.value + el.path}_tree_children`;
  }

  get treeChilStyle() {
    return {
      transition: `${DEFAULT_TRANSITION_TIME}ms ease-out`,
    }
  }

  get treeRowStyle() {
    return {
      height: `${DEFAULT_NODE_HEIGHT}px`,
    }
  }

  // treeChStyle() {
  //   return {
  //     marginLeft: `10px`
  //   }
  // }

  renderNodes(nodes) {
    return (
      <div class="node-list">
        {nodes && nodes.length > 0 && nodes.map(el => (
          <div key={el.value} class="tree-item">
            <div
              class="tree-row"
              style={this.treeRowStyle}>
              <div class="check-buttons">
                <img onClick={e => this.onSelect(e, el)} src={`static/icons/arrows/${this.treeIcons(el)}.svg`} class="dt-icon checkbox" />
              </div>
              {/* <div class="dt-checkbox v2 m0">
                <input
                  type="checkbox"
                  name={el.value}
                  id={el.value}
                  checked={el.selected}
                  onClick={e => this.onSelect(e, el)}
                />
                <div class="checkmark"></div>
              </div> */}
              <div class="checkbox-label">{el.text}</div>
              <div class="expand-buttons">
                {(el.children && el.children.length > 0) ?
                  (el.expanded
                    ? <img onClick={e => this.onMinimize(el)} src="static/icons/arrows/chevron-down.svg" class="dt-icon" />
                    : <img onClick={e => this.onExpand(el)} src="static/icons/arrows/chevron-right.svg" class="dt-icon" />)
                  : undefined
                }
              </div>
            </div>
            {(el.children && el.children.length) ? (
              <div
                id={this.treeChildId(el)}
                class={`tree-children`}
                style={this.treeChilStyle}
              >
                {this.renderNodes(el.children)}
              </div>
            ) : undefined}
          </div>
        ))}
      </div>
    )
  }

  render(createElement) {
    return (
      <div class="select-tree">
        {this.renderNodes(this.treeObj)}
      </div>
    )
  }
}

